import { render, staticRenderFns } from "./RandomChart.vue?vue&type=template&id=0be54aab&scoped=true&"
import script from "./RandomChart.vue?vue&type=script&lang=ts&"
export * from "./RandomChart.vue?vue&type=script&lang=ts&"
import style0 from "./RandomChart.vue?vue&type=style&index=0&id=0be54aab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0be54aab",
  null
  
)

export default component.exports